// Somewhat based on these:
// https://github.com/YellowTugboat/d3-symbol-extra/tree/master/src
// https://github.com/d3/d3-shape/tree/master/src/symbol

var sqrt3 = Math.sqrt(3);
var pi = Math.PI;
var tau = 2 * pi;
function rotatePoint(x, y, theta) {
   return [
     Math.cos(theta) * x + -Math.sin(theta) * y, // x
     Math.sin(theta) * x + Math.cos(theta) * y  // y
   ];
 }

nv.utils.symbolMap.set('thin-x', function(size) {
    size = Math.sqrt(size);
    return 'M' + (-size/2) + ',' + (-size/2) +
            'l' + size + ',' + size +
            'm0,' + -(size) +
            'l' + (-size) + ',' + size;
});

nv.utils.symbolMap.set('triangle-right', function(size) {
   var y = -Math.sqrt(size/(sqrt3));
   
   return 'M' + (y/2) + ',' + (y) +
           'l' + (-sqrt3*y) + ',' + (-y) +
           'l' + (sqrt3*y) + ',' + (-y)
           +'Z';
});

nv.utils.symbolMap.set('triangle-left', function(size) {
   var y = Math.sqrt(size/(sqrt3));
   
   return 'M ' + (y/2) + ', ' + (y) +
   'l ' + (-sqrt3*y) + ', ' + (-y) +
   'l ' + (sqrt3*y) + ', ' + (-y)
   +' Z';
});

var c = -0.5,
   s = Math.sqrt(3) / 2,
   k = 1 / Math.sqrt(12),
   a = (k / 2 + 1) * 3;

nv.utils.symbolMap.set('wye', function(size) {
   var y = Math.sqrt(size);
   var r = Math.sqrt(size / a),
      x0 = r / 2,
      y0 = r * k,
      x1 = x0,
      y1 = r * k + r,
      x2 = -x1,
      y2 = y1;
   return 'M ' + x0 + ' ' + y0 + ' '
      + 'L ' + x1 + ' ' + y1 + ' '
      + 'L ' + x2 + ' ' + y2 + ' '
      + 'L ' + (c * x0 - s * y0) + ' ' + (s * x0 + c * y0) + ' '
      + 'L ' + (c * x1 - s * y1) + ' ' + (s * x1 + c * y1) + ' '
      + 'L ' + (c * x2 - s * y2) + ' ' + (s * x2 + c * y2) + ' '
      + 'L ' + (c * x0 + s * y0) + ' ' + (c * y0 - s * x0) + ' '
      + 'L ' + (c * x1 + s * y1) + ' ' + (c * y1 - s * x1) + ' '
      + 'L ' + (c * x2 + s * y2) + ' ' + (c * y2 - s * x2) + ' '
   + 'Z';
});

nv.utils.symbolMap.set('x', function(size) {
   var r = Math.sqrt(size / 5) / 1.5;
   var theta = tau / 8;

   // Use the same construction points as `symbolCross` and rotate 1/8 turn.
   var points = [
     rotatePoint(-3 * r, -r, theta),
     rotatePoint(-r, -r, theta),
     rotatePoint(-r, -3 * r, theta),
     rotatePoint(r, -3 * r, theta),
     rotatePoint(r, -r, theta),
     rotatePoint(3 * r, -r, theta),
     rotatePoint(3 * r, r, theta),
     rotatePoint(r, r, theta),
     rotatePoint(r, 3 * r, theta),
     rotatePoint(-r, 3 * r, theta),
     rotatePoint(-r, r, theta),
     rotatePoint(-3 * r, r, theta)
   ];
   
   var point = points.pop();
   var path = 'M ' + point[0] + ' ' + point[1] + ' ';
   points.forEach(function(point) {
      path += 'L ' + point[0] + ' ' + point[1] + ' ';
   });
   return path + ' Z';
});

var ka = 0.89081309152928522810,
kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
kx = Math.sin(tau / 10) * kr,
ky = -Math.cos(tau / 10) * kr;
nv.utils.symbolMap.set('star', function(size) {
   var r = Math.sqrt(size * ka),
      x = kx * r,
      y = ky * r;
   var path = 'M 0 ' + (-r) + ' '
      + 'L ' + (x) + ' ' + (y);
   for (var i = 1; i < 5; ++i) {
      var a = tau * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      path += 'L ' + (s*r) + ' ' + (-c*r) + ' ';
      path += 'L ' + (c*x-s*y) + ' ' + (s*x+c*y) + ' ';
   }
   return path + ' Z';
});
